<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-select 
						v-model="filters.spcode" filterable placeholder="选择上游" class="h-m-select">
					  <el-option v-for="item in splist"
						:key="item.spcode" :label="item.name" v-model="item.spcode">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select 
						v-model="filters.cpcode" filterable placeholder="选择渠道" class="h-m-select">
					  <el-option v-for="item in cplist"
						:key="item.cpcode" :label="item.cpname" v-model="item.cpcode">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.s_code" placeholder="SP代码" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.servicecode" placeholder="业务代码" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.code_name" placeholder="业务名称" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
			<el-table-column label="操作" width="100">
				<template slot-scope="scope">
					<div>
						<el-button type="text" size="small" @click="handleTest(scope.$index, scope.row)">生成模拟测试</el-button><br/>
						<el-button type="text" size="small" @click="handleReSend(scope.$index, scope.row)">重新同步</el-button><br/>
						<el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="entime" label="信息" min-width="250">
				<template slot-scope="scope">
					<font color="green">{{scope.row.spcode}}:{{scope.row.name}}</font>&nbsp;&nbsp;&nbsp;&nbsp;
					<font color="blue">{{scope.row.s_code}}:{{scope.row.code_name}}</font><br/>
					渠道:<font color="green">{{scope.row.cpcode}}:{{scope.row.cpname}}</font>&nbsp;&nbsp;&nbsp;&nbsp;
					<font v-if="scope.row.processmd=='2'">异步处理</font>
					<font v-else>同步处理</font>
					<div v-if="scope.row.cmd!=''">
						匹配指令:{{scope.row.cmd}},端口:{{scope.row.addr}} --&gt;
						透传指令:{{scope.row.extend}},端口:{{scope.row.addr}} --&gt;
						cpscode:{{scope.row.servicecode}}
					</div>
					<div v-else>
						透传:<font color="blue" size="4"><u>{{scope.row.extend}}</u></font> --&gt;
						cpscode:<font color="blue" size="4"><u>{{scope.row.servicecode}}</u></font>
					</div>
					<font size="1">{{scope.row.entime}},扣掉:{{scope.row.zsbl}}%,结算:{{scope.row.qdjsdj*0.01}}元
					&nbsp;&nbsp;&nbsp;&nbsp;
					<font color="green" v-if="scope.row.open_provids!=''" size="1">{{scope.row.open_provids}}</font>
					</font>
					<font color="red" v-if="scope.row.isend=='1'" size="4">已设置到量</font>
					
				</template>
			</el-table-column>
			<el-table-column prop="cpcode" label="省份" min-width="110">
				<template slot-scope="scope">
					<div v-if="scope.row.conf_provids!=''">
						<div style="color:green;font-size:12px;" v-for="item in scope.row.conf_provids">{{item.provid}}:{{item.mcl}}%</div>
						<el-button type="text" size="small" @click="addProvidMcl(scope.row)">修改</el-button>
					</div>
					<div v-else>
						<el-button type="text" size="small" @click="addProvidMcl( scope.row)">配置</el-button>
					<div>
				</template>
			</el-table-column>
			<el-table-column prop="cpcode" label="其他" min-width="150">
				<template slot-scope="scope">
					<div style="color:blue">系统参数</div>
					<div>
						<div style="color:green;font-size:12px;" v-for="item in scope.row.param_conf">{{item.set}}</div>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条翻页-->
		<el-col :span="24" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>

		<el-drawer
		  title="添加业务配置"
		  :visible.sync="addFormVisible" :before-close="noCloseDrawer"
		  size="50%"
		  direction="rtl">
			<el-form :inline="true" :model="addFilters">
				<el-form-item>
					<el-select 
						v-model="addFilters.spcode" filterable placeholder="选择上游" class="h-m-select">
					  <el-option v-for="item in splist"
						:key="item.spcode" :label="`${(item.spcode)}:${(item.name)}`" v-model="item.spcode">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input v-model="addFilters.s_code" placeholder="业务编号" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="addFilters.code_name" placeholder="业务名称" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getCodeLists">搜索</el-button>
					<el-button @click.native="addFormVisible = false">取消</el-button>
				</el-form-item>
			</el-form>
			<!--列表-->
			<el-table :data="dataAddlist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="300">
				<el-table-column prop="" label="代码信息" min-width="150">
					<template slot-scope="scope">
						{{scope.row.spcode}}:{{scope.row.spname}}<br/>
						业务:{{scope.row.s_code}}:{{scope.row.code_name}}<br/>
						资费:{{scope.row.fee}}开通省份:{{scope.row.open_provids}}
					</template>
				</el-table-column>
				<el-table-column label="操作" fixed="right" width="100">
					<template slot-scope="scope">
						<div>
							<el-button type="text" size="small" @click="selectEdit(scope.$index, scope.row)">选择</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</el-drawer>
		<!--编辑界面-->
		<el-drawer
		  title="编辑业务配置"
		  :visible.sync="editFormVisible" :before-close="clickClose" :with-header="false"
		  size="50%"
		  direction="rtl">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
				<el-container style="min-height: 100vh;">
					<el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;">
					  <!-- 头部内容 -->
					  <div>
						<el-button @click.native="editFormVisible = false">取消</el-button>
						<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
					  </div>
					</el-header>
					<el-main>
						<el-card class="box-card">
						  <div slot="header" class="clearfix"><span>{{editformtitle}}</span></div>
						  <div class="text item">
							<el-form-item label="上游">
								{{editForm.spcode}}:{{editForm.spname}}
							</el-form-item>
							<el-form-item label="SP业务信息" label-width="auto">
								{{editForm.s_code}}:{{editForm.code_name}}
							</el-form-item>
							<el-form-item label="选择渠道" prop="cpcode" label-width="auto">
								<el-select 
									v-model="editForm.cpcode" filterable placeholder="选择渠道" class="h-m-select">
								  <el-option v-for="item in cplist"
									:key="item.spcode" :label="item.cpname" v-model="item.cpcode">
								  </el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="透传" prop="extend">
								<el-input v-model="editForm.extend" placeholder="透传" @blur="inputExtend"></el-input>
							</el-form-item>
							<el-form-item label="渠道业务代码" label-width="auto">
								{{editForm.servicecode}}
								<el-tag effect="dark" v-if="checkInSpService" type="danger">存在此代码请更改!</tag>
							</el-form-item>
							<el-form-item label="扣掉%" prop="zsbl">
								<el-input v-model="editForm.zsbl" placeholder="比例"></el-input>
							</el-form-item>
							<el-form-item label="qd结算(分)" prop="qdjsdj">
								<el-input v-model="editForm.qdjsdj" placeholder="渠道结算单价"></el-input>
							</el-form-item>
							<el-form-item label="老系统模糊路由指令" label-width="auto">
								<el-input v-model="editForm.cmd" placeholder="指令"></el-input>
							</el-form-item>
							<el-form-item label="老系统模糊路由端口" label-width="auto">
								<el-input v-model="editForm.addr" placeholder="端口"></el-input>
							</el-form-item>
							<el-form-item label="选择提交处理方式" prop="processmd" label-width="auto">
								<el-select 
									v-model="editForm.processmd" filterable placeholder="选择处理方式" class="h-m-select">
								  <el-option value="1" label="同步处理"></el-option>
								  <el-option value="2" label="异步处理"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="设置是否到量" prop="isend" label-width="auto">
								<el-select 
									v-model="editForm.isend" filterable placeholder="选择是否到量" class="h-m-select">
								  <el-option value="0" label="未到量"></el-option>
								  <el-option value="1" label="今日到量"></el-option>
								</el-select>
							</el-form-item>
							
						  </div>
						</el-card>		
					</el-main>
				</el-container>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				
			</div>
		</el-drawer>
		<!--编辑省份信息-->
		<el-drawer
		  title="编辑省份"
		  :visible.sync="editProvidFormVisible" :before-close="clickClose" :with-header="false"
		  size="50%"
		  direction="rtl">
			<el-form :model="editProvidForm" label-width="100px" :rules="formRules" ref="editProvidForm">
				<el-container style="min-height: 100vh;">
					<el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;">
					  <!-- 头部内容 -->
					  <div>
						<el-button @click.native="editProvidFormVisible = false">取消</el-button>
						<el-button type="primary" @click.native="editProvidSubmit" :loading="editLoading">提交</el-button>
					  </div>
					</el-header>
					<el-main>
						<el-card class="box-card">
						  <div slot="header" class="clearfix"><span>编辑省份</span></div>
						  <div class="text item" v-for="items in editTempProvids">
							<el-form-item :label="items.provid">
								<el-input v-model="items.mcl" placeholder="扣量"></el-input>%
							</el-form-item>
						  </div>
						</el-card>		
					</el-main>
				</el-container>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				
			</div>
		</el-drawer>
		<el-dialog title="生成模拟测试" :visible.sync="testFormVisible" :close-on-click-modal="false">
			<el-form :model="testForm" label-width="100px" :rules="testFormRules" ref="testForm">
				<el-form-item label="手机号码" prop="mobile">
					<el-input v-model="testForm.mobile" placeholder="测试号码"></el-input>
				</el-form-item>
				<el-form-item label="统一下单URL">
					{{testForm.sendCode}}
					<el-button v-if="testForm.sendCode!=''" type="primary" @click.native="testOpenSendCode">调用</el-button>
				</el-form-item>
				<el-form-item label="统一提交URL">
					{{testForm.doSubmit}}
					<el-button v-if="testForm.doSubmit!=''" type="primary" @click.native="testOpenSumit">调用</el-button>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="testFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="testSubmit" :loading="editLoading">生成</el-button>
			</div>
		</el-dialog>
		<el-dialog title="重新同步" :visible.sync="reSendFormVisible" :close-on-click-modal="false">
			<el-form :model="reSendForm" label-width="100px" :rules="reSendFormRules" ref="reSendForm">
				<el-form-item label="重新同步代码">
					{{reSendForm.cpscode}}
				</el-form-item>
				<el-form-item label="时间">
					<el-date-picker
						v-model="reSendForm.entime"
						value-format="yyyy-MM-dd"
						style="width:100%"
						 type="date"
						 placeholder="选择日期"
					   />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="reSendFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="reSendSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					spcode:'',cpcode:'',s_code:'',servicecode:'',code_name:''
				},
				addFilters:{
					spcode:'',s_code:'',code_name:''
				},
				isModiFy:false,
				checkInSpService:false,
				splist:[],
				cplist:[],
				datalist: [],
				dataAddlist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				/////////
				addFormVisible:false,
				editLoading: false,
				formRules: {
					spcode :[
						{required: true,message: '编号不能为空!',trigger: 'blur'}
					],
					cpcode :[
						{required: true,message: '名称不能为空!',trigger: 'blur'}
					],
					s_code :[
						{required: true,message: 'SP代码不能为空!',trigger: 'blur'}
					],
					servicecode :[
						{required: true,message: '业务代码不能为空!',trigger: 'blur'}
					],
					extend :[
						{required: true,message: '透传不能为空!',trigger: 'blur'}
					],
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',entime:'',spcode:'',cpcode:'',s_code:'',servicecode:'',extend:'',spname:'',code_name:'',cmd:'',addr:'',processmd:'',isend:'0',zsbl:'80',qdjsdj:'0'
				},
				testFormVisible:false,
				testForm:{
					mobile:'',sendCode:'',doSubmit:'',servicecode:'',extend:''
				},
				reSendFormVisible:false,
				reSendForm:{
					cpscode:'',entime:'',actionurl:'control/reSynched'
				},
				//////////编辑省份
				editProvidFormVisible:false,
				editProvidId:'',
				editTempProvids:[]
			}
		},
		methods: {
			editProvidMcl:function(row){
				this.editProvidId = row.id;
				this.editTempProvids = [] ;
				for (let i = 0; i < row.conf_provids.length; i++) {
					this.editTempProvids.push(row.conf_provids[i]);
				}
				this.editProvidFormVisible = true ;
			},
			checkInSpvoids:function(theProvid){
				for (let i = 0; i < this.editTempProvids.length; i++) {
					if(this.editTempProvids[i].provid==theProvid){
						return true ;
					}
				}
				return false ;
			},
			addProvidMcl:function(row){
				console.log("Add");
				this.editProvidId = row.id;
				this.editTempProvids = [] ;
				try{
					for (let i = 0; i < row.conf_provids.length; i++) {
						try{
							if(row.open_provids.indexOf(row.conf_provids[i].provid)>=0){
								this.editTempProvids.push(row.conf_provids[i]);
							}else{
								console.log("移除:"+row.conf_provids[i].provid);
							}
						}catch(ee){}
					}
				}catch(e){}
				this.editProvidFormVisible = true ;
				//检测...
				try{
					let addsp = row.open_provids.split(",");
					for (let i = 0; i < addsp.length; i++) {
						if(!this.checkInSpvoids(addsp[i])){
							let newAddObj = {};
							newAddObj.provid = addsp[i];
							newAddObj.mcl = row.zsbl;
							console.log("add:"+addsp[i]);
							this.editTempProvids.push(newAddObj);
						}
					}
				}catch(e){
					console.log(e);
				}
			},
			editProvidSubmit:function(){
				for (let i = 0; i < this.editTempProvids.length; i++) {
					console.log(this.editTempProvids[i].mcl);
				}
				let confProvids = JSON.stringify(this.editTempProvids);
				let submitProvidFrom = {
					actionurl:'default/save',
					sqlid:'gjfPDIGp.spinfo.uptServiceCfProvid',
					id:this.editProvidId,
					conf_provids:confProvids
				};
				getListPage(submitProvidFrom).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.$message({message: "修改完成!",type: "success"});
						this.getLists();
					}
					this.editProvidFormVisible = false ;
				});
			},
			clickClose:function(){},
			inputExtend(){
				this.editLoading = true ;
				this.editForm.servicecode = this.editForm.extend + "T" + this.editForm.s_code;
				//检测代码是否存在
				let para = {
					actionurl:'default/getListAll',
					servicecode:this.editForm.servicecode,
					checkId:this.editForm.id,
					sqlid:'sp_service.checkQuery'
				};
			
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						if(res.data.total>0) this.checkInSpService = true ;//存在
						else this.checkInSpService = false ;
					}
					this.editLoading = false;
				});
			},
			handleCurrentChange:function(val){
				this.page = val;
				this.getLists();
			},
			noCloseDrawer(){
				this.$message({message: "关闭可点击取消按键!",type: "success"});
			},
			getSpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'sp_spinfo.query'
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.splist = res.data.datas;
					}
				});
				
			},
			getCpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'sp_cpinfo.query'
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.cplist = res.data.datas;
					}
				});
				
			},
			getCodeLists:function(){
				if(this.addFilters.spcode==''&&this.addFilters.s_code==''&&this.addFilters.code_name==''){
					this.$message({message: "请选择一个条件!",type: "error"});
					return ;
				}
				let para = {
					actionurl:'default/getListAll',
					spcode:this.addFilters.spcode,
					s_code:this.addFilters.s_code,
					code_name:this.addFilters.code_name,
					sqlid:'sp_spConf.query'
				};
				//this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.dataAddlist = res.data.datas;
					}
					//this.listLoading = false;
				});
			},
			getLists:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					spcode:this.filters.spcode,
					cpcode:this.filters.cpcode,
					s_code:this.filters.s_code,
					servicecode:this.filters.servicecode,
					code_name:this.filters.code_name,
					sqlid:'sp_service.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
				if(this.isModiFy) {
					this.runExec();
					this.isModiFy = false ;
				}
			},
			runExec:function(){
				let para = {
					actionurl:'control/reloads'
				};
				delData(para).then((res) => {
					//this.listLoading = false;
					this.$message({message: res.data.message,type: res.data.type});
					//this.getLists();
				});
			},
			handleAdd:function(){
				this.addFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',sqlid:'sp_service.add',entime:'',spcode:'',cpcode:'',s_code:'',servicecode:'',extend:'',cmd:'',addr:'',processmd:'',isend:'0',zsbl:'80',qdjsdj:'0'
				};
			},
			handleReSend:function (index, row) {
				this.reSendFormVisible = true ;
				this.reSendForm.cpscode = row.servicecode ;
				this.reSendForm.entime = util.formatDate.getdatestr(0, 'yyyy-MM-dd');
			},
			reSendSubmit:function(){
				//let para = {
					//actionurl:'control/reSynched'
				//};
				delData(this.reSendForm).then((res) => {
					//this.listLoading = false;
					this.$message({message: res.data.message,type: res.data.type});
				});
			},
			handleTest:function (index, row) {
				this.testFormVisible = true ;
				this.testForm.servicecode = row.servicecode ;
				this.testForm.extend = row.extend;
			},
			testSubmit:function(){
				let sjx = Math.floor(Math.random() * (100000000 - 10000000 + 1) + 10000000);
				this.testForm.sendCode = "http://"+window.location.host+"/ssm/unified/sendCode?mobile=" +
					this.testForm.mobile + "&cpscode="+ this.testForm.servicecode +"&cporder="+this.testForm.extend + sjx;
				this.testForm.doSubmit = "http://"+window.location.host+"/ssm/unified/doSubmit?mobile=" +
					this.testForm.mobile + "&cpscode="+ this.testForm.servicecode +"&cporder="+this.testForm.extend + sjx+"&code=100001";
			},
			testOpenSendCode:function(){
				window.open(this.testForm.sendCode);
			},
			testOpenSumit:function(){
				window.open(this.testForm.doSubmit);
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = {
					id:row.id,
					actionurl:'default/save',sqlid:'sp_service.upt',spcode:row.spcode,
					cpcode:row.cpcode,s_code:row.s_code,
					servicecode:row.servicecode,extend:row.extend,spname:row.name,code_name:row.code_name,cmd:row.cmd,addr:row.addr,processmd:row.processmd,isend:row.isend,zsbl:row.zsbl,qdjsdj:row.qdjsdj
				};
				if(this.editForm.qdjsdj=='') this.editForm.qdjsdj='0';
			},
			selectEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '添加渠道业务';
				this.editForm = {
					actionurl:'default/save',sqlid:'sp_service.add',
					spcode:row.spcode,s_code:row.s_code,spname:row.spname,
					code_name:row.code_name,
					cpcode:'',servicecode:'',extend:''
				};
				this.editForm.servicecode = '透传T'+ row.s_code ;
			},
			editSubmit:function(){
				//检测代码是否存在
				if(this.checkInSpService) {
					this.$message({message: "代码重复，不可提交!",type: "error"});
					return ;
				}
				this.addFormVisible = false ;
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
				this.isModiFy = true ;
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					let para = {
						actionurl:'default/del',
						sqlid:'sp_service.del',
						id:row.id
					};
					delData(para).then((res) => {
						this.listLoading = false;
						this.$message({message: res.data.message,type: res.data.type});
						this.getLists();
					});
				}).catch(() => {});
			}
		},
		mounted() {
			this.getCpList();
			this.getSpList();
			this.getLists();
		}
	}	
</script>
<style scoped>
	.gradient-multicolor {
		color:#CC9966;
		font-size:15px
	}
	.el-input {
		width: 150px;
	}
	.el-header {
	  background-color: #FFFFFF;
	  //color: white;
	  text-align: left;
	  line-height: 60px;
	}
	 
	.el-main {
	  margin-top: 60px; /* 头部高度 */
	  padding: 0px;
	}
</style>


// WEBPACK FOOTER //
// service.vue?0dcfd5f6